import { useUserFeedbackSurvey } from 'api/healthCoach/useUserFeedback';
import BlockFeedbackItem from 'components/UserDashboard/overview/BlockFeedbackItem';
import { UserBlock } from 'models/block';

type Props = {
  block: UserBlock;
};

export const BlockFeedback = ({ block }: Props) => {
  const { userFeedbackSurveyData } = useUserFeedbackSurvey({
    user_block_id: block.id,
    order_by: 'asc',
  });

  return (
    <>
      {userFeedbackSurveyData?.map((feedbackItem) => {
        return (
          <BlockFeedbackItem
            key={feedbackItem.id}
            feedbackItem={feedbackItem}
          />
        );
      })}
    </>
  );
};

export default BlockFeedback;
